import iconFail from "assets/img/icons/icon-warning.svg";

const CancelListingFail = ({step, closeWindow}) => {
  return (
    <>
      <header className="modal-window__header">
        <img src={iconFail} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Something went wrong</h5>
        <p className="modal-window__info">Cancel listing was not completed. <br /> {step.includes('401') ? 'You have to log in' : ''} </p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={closeWindow}>Done</button>
      </footer>
    </>
  )
}

export default CancelListingFail;
